import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Select, CheckedImage } from '../../../common/commonIndex';
// import EmailService from '../../../services/API/emailService';
import { Image } from 'components/componentIndex';
import EmailIcon from '../../../assets/images/Union.svg';
import useAuthentication from "../../../hooks/userAuthenticatication/useAuthentication";
import { toast } from 'react-toastify';

const StepPhoneNumber = ({
  countryCodes,
  selectedCountry,
  formValues,
  phoneRegex,
  mobileNumber,
  handleCountryChange,
  handleInputChange,
  handleSubmit,
  isSubmit,
  handleNextEvent,
  currentUser,
  isEmailShow,
  setIsEmailShow
}) => {
  const { dispatchSignInWithEmailLink } = useAuthentication();
  const [isEmail, setIsEmail] = useState(false);
  const [email, setEmail] = useState();
  const [isValid, setIsValid] = useState(false);
  const [isError, setIsError] = useState(true);
  const [isEmailSubmit, setIsEmailSubmit] = useState(false);

  const handleRedirect = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  useEffect(() => {
    const findIsEmail = localStorage.getItem('isEmail');
    if(findIsEmail === 'true' || isEmailShow){
      setIsEmail(true);
    }else{
      setIsEmail(false);
    }
  }, [isEmailShow, localStorage.getItem('isEmail')])
  const handleWithEmail = () => {
    setIsEmail(!isEmail);
    setIsEmailShow(!isEmail);
    formValues.mobileNumber = null;
    formValues.email = null;
    setEmail(null);
    localStorage.removeItem('isEmail');
  }

  // Function to validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validateEmail = (email) => {
    return emailRegex.test(email);
  };
  // Handle email input change
  const handleEmailChange = (e) => {
    const value = e;
    setEmail(value);
    if (!isError) {
      setIsError(validateEmail(email));
    }
    setIsValid(validateEmail(value));
    formValues.email = value;
  };

  // Handle form submission
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsError(validateEmail(email));
    if (!validateEmail(email)) {
      return;
    }
    handleSignInWithEmail(email);
  };

  const handleSignInWithEmail = async (email) => {
    try {
      // SignInWithEmailLink
      setIsEmailSubmit(true);
      const credentials = { emailAddress: `${email}` };
      const res = await dispatchSignInWithEmailLink(credentials);
      if (res && res.statusCode === 200) { // Check if response code is 200 (successful)
        formValues['session'] = res?.result?.session;
        formValues['magicToken'] = res?.result?.magicToken;
        localStorage.setItem('emailAddress', `${email}`);
        setIsEmailSubmit(false);
        toast.success('Magic link send to your email');
        // handleNextEvent(1);
        // navigator('/loginverify');
      } else {
        setIsEmailSubmit(false);
        console.warn("Login unsuccessful", res.message || "Unauthorized access");
      }
    } catch (error) {
      setIsEmailSubmit(false);
      console.error("Login failed: ", error);
    }
  }

  return (
    <div className="login-box">
      <h1 className="title">Welcome to GutChek</h1>
      <p className="sub-title">Log in or sign up to get started.</p>

      <form onSubmit={isEmail ? handleEmailSubmit : handleSubmit}>
        {isEmail ? (
          <div className="">
            {/* email-form-container */}
            <div className={`input-group ${isValid ? 'valid' : ''} `}>
              <Image imgUrl={EmailIcon} altText="Email" />
              <Input inputType={'email'} inputPlaceholder={'Email'}
                className={'form-control'}
                required={true}
                value={email}
                name={'email1'}
                onChange={handleEmailChange}
              />
              {isValid && (
                <CheckedImage />
              )}

            </div>
            <div className="error-content pt-0">
              <p className="is-error mb-0">{!isError ? email?.trim() !== '' ? 'Invalid email format' : 'Email is required' : ''}</p>
            </div>

          </div>
        ) : (
          <div className="input-group">
            <Select
              defaultValue={selectedCountry}
              list={countryCodes}
              value={formValues?.countryCodes}
              className={'bg-transparent'}
              onChange={(value) => handleCountryChange('countryCodes', value)}
            />
            <div className='line'></div>
            <Input
              inputType={'text'}
              inputPlaceholder={'Mobile number'}
              className={'form-control'}
              required={true}
              isPhoneNumber={true}
              value={formValues?.mobileNumber}
              onChange={(value) => handleInputChange('mobileNumber', value)}
            />
            {phoneRegex.test(mobileNumber) && <CheckedImage />}
          </div>
        )}

        <p className={`security-text ${isEmail ? 'mt-0' : ''}`}>
          {/* We'll only use this securely to log you in and manage your account. By continuing, you agree to our{' '} */}
          By continuing, you consent to receive SMS messages from GutChek for account verification and appointment updates. Reply STOP to opt out. Message and data rates may apply.{' '} 
          <a href="javascript:void(0)" onClick={(e) => handleRedirect('https://gutchek.io/terms/')}>Terms</a> and <a href="#" onClick={(e) => handleRedirect('https://gutchek.io/privacy/')}>Privacy Policy</a>.
        </p>

        <div className="sign-button-content">
          <Button
            btnClass={'btn-primary'}
            btnType={'submit'}
            btnName={'Continue'}
            onClick={isEmail ? handleEmailSubmit : handleSubmit}
            isDisabled={isEmail ? true : phoneRegex?.test(mobileNumber)}
          />
          {/* {isSubmit ? 1 : 2} */}
          {!isSubmit && (
            <div className="spinner-border text-light btn-loader" role="status">
              <span className="sr-only"></span>
            </div>
          )}
          {isEmailSubmit && (
            <div className="spinner-border text-light btn-loader" role="status">
              <span className="sr-only"></span>
            </div>
          )}
        </div>
        {isEmail && (
          <div className="sign-button-content mt-5 security-text ">
            <a href='#' className='signin-with-link-txt' onClick={handleWithEmail}>{`SignIn with ${isEmail ? 'phone number' : 'email'}`}</a>
          </div>
        )}
      </form >
    </div >
  );
};

StepPhoneNumber.propTypes = {
  countryCodes: PropTypes.array.isRequired,
  selectedCountry: PropTypes.object.isRequired,
  formValues: PropTypes.object.isRequired,
  phoneRegex: PropTypes.instanceOf(RegExp).isRequired,
  mobileNumber: PropTypes.string.isRequired,
  handleCountryChange: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmit: PropTypes.bool.isRequired,
};

export default StepPhoneNumber;
